// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.imgs{\n   height: 70px; width: 70px;margin:4px;cursor: pointer;\n}\n.el-drawer {\n    overflow: scroll;\n}\n", ""]);
// Exports
module.exports = exports;
